module.exports = __webpack_public_path__ + "static/media/help.9086f1a6.svg";